
// @flow
export const SALES_TYPE_PERSONAL: 'personal' = 'personal';
export const SALES_TYPE_COMPLEX: 'complex' = 'complex';
export const SALES_TYPE_ALL: 'all' = 'all';
